import {AnyElement, create, ifjs, signalMap, StringOrSignal} from "../../fjsc/src/f2.ts";
import {signal, Signal} from "../../fjsc/src/signals.ts";
import {Bingo} from "./bingo.ts";

export const data = [
    "Taylor Swift",
    "Skipped Folie zu schnell",
    "Schlechte Laune",
    "\"Lest den Text zum nächsten Mal\"",
    "Falschaussagen",
    "Sex, Dating, Beziehungen",
    "Gruppenarbeit",
    "Liest von der Folie ab",
    "Stereotypen",
    "Kaffee oder Getränk in der Hand",
    "\"leider\"",
    "Fließtext auf der Folie",
    "Fragen, auf die er keine Antwort kriegt",
    "Wir präsentieren (nicht er)",
    "Unterschwelliger Rassismus",
    "(weiße, alte) Philosophen",
    "Ist am Handy",
    "Sitzt auf dem Tisch",
    "Fußball",
    "Überschneidung mit anderen Fächern",
    "Keine Motivation",
    "Misogynie",
    "Komische Aussprache von Wörtern",
    "Erwähnt seine Arbeit",
];

export class Generics {
    static bingo() {
        return Generics.pageFrame(
            Bingo.bingo(data)
        );
    }

    static pageFrame(...content: (AnyElement|Signal<AnyElement>)[]) {
        return create("div")
            .classes("flex-v")
            .children(
                ...content
            ).build();
    }

    static container(layer: number, content: (AnyElement|Signal<AnyElement>)[], extraClasses: string[] = []) {
        return create("div")
            .classes("layer-" + layer, ...extraClasses)
            .children(...content)
            .build();
    }

    static message(message: StringOrSignal) {
        return ifjs(message, create("span")
            .text(message)
            .build());
    }

    static image(src: StringOrSignal, extraClasses: StringOrSignal[] = []) {
        return create("img")
            .classes(...extraClasses)
            .src(src)
            .build();
    }

    static icon(icon: StringOrSignal) {
        return create("i")
            .classes("material-symbols-outlined")
            .text(icon)
            .build();
    }

    static list<T>(entries: Signal<T[]>|T[], template: (entry: T) => AnyElement) {
        if (entries instanceof Signal) {
            return create("div")
                .classes("container", "layer-2")
                .children(
                    signalMap(entries, create("div").classes("flex-v"), template)
                ).build();
        }

        return create("div")
            .classes("container", "layer-2", "flex-v")
            .children(
                ...entries.map(template)
            ).build();
    }

    static loading() {
        return create("div")
            .classes("loading")
            .build();
    }

    static heading(level: number, text: StringOrSignal) {
        return create(`h${level}`)
            .text(text)
            .build();
    }

    static table<T>(headers: StringOrSignal[], entries: Signal<T[]>|T[], rowTemplate: (entry: T) => AnyElement) {
        if (entries instanceof Signal) {
            return create("table")
                .classes("container", "layer-2")
                .children(
                    create("thead")
                        .children(
                            create("tr")
                                .children(
                                    ...headers.map(c => create("th").text(c).build())
                                ).build()
                        ).build(),
                    signalMap(entries, create("tbody"), rowTemplate)
                ).build();
        }

        return create("table")
            .classes("container", "layer-2")
            .children(
                create("thead")
                    .children(
                        create("tr")
                            .children(
                                ...headers.map(c => create("th").text(c).build())
                            ).build()
                    ).build(),
                create("tbody")
                    .children(
                        ...entries.map(rowTemplate)
                    ).build()
            ).build();
    }

    static privateText(text: string) {
        const hidden = signal(true);

        return create("span")
            .classes("privateText")
            .onclick(() => hidden.value = !hidden.value)
            .children(
                ifjs(hidden, create("span")
                    .text(text)
                    .build(), true),
                ifjs(hidden, create("span")
                    .text("*".repeat(text.length))
                    .build())
            ).build();
    }

    static tableRow(...data: any[]) {
        return create("tr")
            .children(
                ...data.map(d => create("td").text(d).build())
            ).build();
    }
}

